import {BaseRouteMetaDataModel} from "../../../../../infrastructure/models/route/base-route.meta-data.model";

export class CompetitionMedalsPageRouteMetaDataModel extends BaseRouteMetaDataModel {
  get pageTitle() {
    return 'medals page title';
  }

  get description() {
    return 'medals page description'
  }
}